import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

/* Telas Home */
import Tela_Home from './pages/Tela_Home';

/* Telas Conexion */
import Tela_TesteConnection from './pages/Tela_Teste_Conexão';

/* Telas do Moises */
import CAD_Estudante from './pages/Profissional_Saude/CAD_Estudante';
import Cad_MedicoTutor from './pages/Profissional_Saude/CAD_MedicoTutor';
import Cad_MedicoEspec from './pages/Profissional_Saude/CAD_MedicoEspec';
import Con_Conf_A from './pages/Profissional_Saude/Con_Conf_A';
import Con_Conf_MT from './pages/Profissional_Saude/Con_Conf_MT';
import Con_Pass_A from './pages/Profissional_Saude/Con_Pass_A';
import Con_Pass_MT from './pages/Profissional_Saude/Con_Pass_MT';
import Con_Pend_A from './pages/Profissional_Saude/Con_Pend_A';
import Con_Pend_MT from './pages/Profissional_Saude/Con_Pend_MT';
import Con_alRes_MT from './pages/Profissional_Saude/Con_alRes_MT';
import Con_al_MT from './pages/Profissional_Saude/Con_al_MT';
import Interface_A from './pages/Profissional_Saude/Interface_A';
import Interface_MT from './pages/Profissional_Saude/Interface_MT';
import Login_M from './pages/Profissional_Saude/Login_M';
import Tela_PS_Home from './pages/Profissional_Saude/Tela_PS';
import Tela_PS_Cadastro from './pages/Profissional_Saude/Tela_PS_Cadastro';
import Tela_PS_ConsCo from './pages/Profissional_Saude/Tela_PS_ConsCo';
import Tela_PS_ConsPa from './pages/Profissional_Saude/Tela_PS_ConsPa';
import Tela_PS_ConsPe from './pages/Profissional_Saude/Tela_PS_ConsPe';
import Tela_PS_Painel from './pages/Profissional_Saude/Tela_PS_Painel';
import Prontuario_Inicial from './pages/Profissional_Saude/Prontuario_Inicial';
import Monitoramento from './pages/Profissional_Saude/Prescricao_Monitoramento';

/* Telas da Sabrina */
import Tela_OG from './pages/Organizador/Tela_OG';
import Tela_Consultas from './pages/Organizador/Tela_Consultas';
import Tela_Login_Organizador from './pages/Organizador/Tela_Login_Organizador';
import Tela_Consulta_Pendente from './pages/Organizador/Tela_Consulta_Pendente';
import Tela_Consulta_Encaminhada from './pages/Organizador/Tela_Consulta_Encaminhada';
import Tela_Pedidos_de_Inscricao from './pages/Organizador/Tela_Pedidos_de_Inscricao';
import Tela_Pedidos_Profissionais from './pages/Organizador/Tela_Pedidos_Profissionais';
import Tela_Pedidos_Instituicoes from './pages/Organizador/Tela_Pedidos_Instituicoes';
import Tela_Cadastros from './pages/Organizador/Tela_Cadastros';
import Tela_Instituicoes_Cadastradas from './pages/Organizador/Tela_Instituicoes_Cadastradas';
import Tela_Profissionais_Cadastrados from './pages/Organizador/Tela_Profissionais_Cadastrados';


/* Telas do Antonio */
import RI from './pages/Representante_Instituição/Tela_RI';
import RI_Cadastro from './pages/Representante_Instituição/Tela_RI_Cadastro';
import RI_Consulta from './pages/Representante_Instituição/Tela_RI_Consulta';
import RI_ConsultasDetalhes from './pages/Representante_Instituição/Tela_RI_Consultas_Detalhes';
import RI_Login from './pages/Representante_Instituição/Tela_RI_Login';
import RI_PacientesCadastro from './pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro';
import RI_PacientesDetalhes from './pages/Representante_Instituição/Tela_RI_Pacientes_Detalhes';
import RI_PacientesLista from './pages/Representante_Instituição/Tela_RI_Pacientes_Lista';
import RI_Painel from './pages/Representante_Instituição/Tela_RI_Painel';
import RI_SolicitarConsulta from './pages/Representante_Instituição/Tela_RI_Solicitar_Consulta';
import { isAuthenticated } from './services/Auth';

const PrivateRoute = ({component: Component, ...rest}) => (
  <Route
    {...rest}
    render={props => 
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/', state: { from: props.location } }}/>
      )
    }
  />
);


export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        
        <Route path="/" exact component={Tela_Home} />

        <Route path="/cad_estudante" exact component={CAD_Estudante}/>;
        <Route path="/cad_medico_espec" exact component={Cad_MedicoEspec}/>;
        <Route path="/cad_medico_tutor" exact component={Cad_MedicoTutor}/>;
        <PrivateRoute path="/con_conf_a" exact component={Con_Conf_A}/>;
        <PrivateRoute path="/con_conf_mt" exact component={Con_Conf_MT}/>;
        <PrivateRoute path="/con_alres_mt" exact component={Con_alRes_MT}/>;
        <PrivateRoute path="/con_al_mt" exact component={Con_al_MT}/>;
        <PrivateRoute path="/con_pass_a" exact component={Con_Pass_A}/>;
        <PrivateRoute path="/con_pass_mt" exact component={Con_Pass_MT}/>;
        <PrivateRoute path="/con_pend_a" exact component={Con_Pend_A}/>;
        <PrivateRoute path="/con_pend_mt" exact component={Con_Pend_MT}/>;
        <PrivateRoute path="/interface_a" exact component={Interface_A}/>;
        <PrivateRoute path="/interface_mt" exact component={Interface_MT}/>;
        <Route path="/login_m" exact component={Login_M}/>;
        <Route path="/tela_ps" exact component={Tela_PS_Home}/>;
        <Route path="/tela_ps_cadastro" exact component={Tela_PS_Cadastro}/>;
        <PrivateRoute path="/tela_ps_cc/:id" exact component={Tela_PS_ConsCo}/>;
        <PrivateRoute path="/tela_ps_cpa/:id" exact component={Tela_PS_ConsPa}/>;
        <PrivateRoute path="/tela_ps_cpe/:id" exact component={Tela_PS_ConsPe}/>;
        <PrivateRoute path="/prontuario_inicial/:id" exact component={Prontuario_Inicial}/>;
        <PrivateRoute path="/monitoramento/:id" exact component={Monitoramento}/>;
        <PrivateRoute path="/tela_ps_painel" exact component={Tela_PS_Painel}/>;
      
        <Route path="/RI" exact component={RI}/>
        <Route path="/RI_Cadastro" exact component={RI_Cadastro}/>
        <PrivateRoute path="/RI_Consulta/:id" exact component={RI_Consulta}/>
        <PrivateRoute path="/RI_ConsultasDetalhes/:id" exact component={RI_ConsultasDetalhes}/>
        <Route path="/RI_Login" exact component={RI_Login}/>
        <PrivateRoute path="/RI_PacientesCadastro" exact component={RI_PacientesCadastro}/>
        <PrivateRoute path="/RI_PacientesDetalhes/:id" exact component={RI_PacientesDetalhes}/>
        <PrivateRoute path="/RI_PacientesLista/:id" exact component={RI_PacientesLista}/>
        <PrivateRoute path="/RI_Painel" exact component={RI_Painel}/>
        <PrivateRoute path="/RI_SolicitarConsulta/:id" exact component={RI_SolicitarConsulta}/>

        <PrivateRoute path="/Tela_OG" exact component={Tela_OG} />;
        <PrivateRoute path="/Tela_Consultas"exact component={Tela_Consultas}/>;
        <PrivateRoute path="/Tela_Consulta_Pendente/:id"exact component={Tela_Consulta_Pendente}/>;  
        <Route path="/Tela_Login_Organizador"exact component={Tela_Login_Organizador}/>;       
        <PrivateRoute path="/Tela_Consulta_Encaminhada/:id" exact component={Tela_Consulta_Encaminhada}/>;
        <PrivateRoute path="/Tela_Pedidos_de_Inscricao"exact component={Tela_Pedidos_de_Inscricao}/>;
        <PrivateRoute path="/Tela_Pedidos_Profissionais/:id"exact component={Tela_Pedidos_Profissionais}/>;
        <PrivateRoute path="/Tela_Pedidos_Instituicoes/:id"exact component={Tela_Pedidos_Instituicoes}/>;
        <PrivateRoute path="/Tela_Cadastros"exact component={Tela_Cadastros}/>;
        <PrivateRoute path="/Tela_Instituicoes_Cadastradas/:id"exact component={Tela_Instituicoes_Cadastradas}/>;
        <PrivateRoute path="/Tela_Profissionais_Cadastrados/:id"exact component={Tela_Profissionais_Cadastrados}/>;

        <Route path="/Tela_TesteAxios"exact component={Tela_TesteConnection}/>;
      </Switch>
    </BrowserRouter>
  );
}
